import { useTranslation } from 'react-i18next';
import TrendLineChart from './components/TrendLineChart';
import TrendBarChart from './components/TrendBarChart';
import TrendHeatmap from './components/TrendHeatmap';

const TrendChartFactory = (props) => {
    const { data, timeAggType, currencySymbol, graphTypes } = props;
    const {t} = useTranslation()
    return (
        <>
        {[
            "TEMPERATURE", 
            "SET_POINT", 
            "OUTSIDE_TEMP",
            "CONSUMPTION_MONEY",
            "CONSUMPTION_KWH",
            "POWER_METER", 
            "GAS_METER",
            "APPARENT_POWER",
            "VOLTAGE",
            "CURRENT",
            "POWER_FACTOR",
            "CO2",
            "HUMIDITY",
            "PRESSURE",
            "PM2_5",
            "PM10",
            "VOC"
        ].filter(d => graphTypes.includes(d)).map((graphType) => (
        <TrendLineChart graphType={graphType}
            data={data}
            timeAggType={timeAggType}
            currencySymbol={currencySymbol}
            key={`graph-${graphType}`}/>)) }
        {[
            "ENERGY_PRICE", 
            "CARBON_INTENSITY",
            
        ].filter(d => graphTypes.includes(d)).map((graphType) => ( <TrendBarChart graphType={graphType}
        data={data}
        timeAggType={timeAggType}
        currencySymbol={currencySymbol}
        key={`graph-${graphType}`}/>))}
        {[
            "FAN_SPEED", 
            "MODE", 
            "ON_OFF",
            "MOTION",
            
        ].filter(d => graphTypes.includes(d)).map((graphType) => ( <TrendHeatmap graphType={graphType}
        data={data}
        timeAggType={timeAggType}
        currencySymbol={currencySymbol}
        key={`graph-${graphType}`}/>))}
        </> 
     );
}
 
export default TrendChartFactory;